<template>
  <div class="table" v-if="estimateItemList.length > 0">
    <div class="table-row">
      <p>№</p>
      <p class="center">Opening</p>
      <p class="center">W</p>
      <p class="center">H</p>
      <p class="center">Sq ft.</p>
      <p class="center">Material Price</p>
      <p class="center">Overhead</p>
      <p class="center">Service</p>
      <p class="center">Partition total</p>
    </div>

    <div
      class="table-row"
      v-for="(item, index) in estimateItemList"
      :key="`installation-item-${index}`"
    >
      <p>{{ index + 1 }}</p>
      <p class="center">{{ item.title }}</p>
      <p class="center">{{ item.width }}</p>
      <p class="center">{{ item.height }}</p>
      <p class="center">{{ item.qty }}</p>
      <PriceValue class="table-price" :price="item.price" />
      <PriceValue class="table-price" :price="item.overheadPrice" />
      <PriceValue
        v-if="servicePrice > 0"
        class="table-price"
        :price="item.servicePrice"
      />
      <p v-else class="table-price">-</p>
      <PriceValue class="table-price" :price="item.sum" />
    </div>

    <div class="table-row total" v-if="estimateTotal">
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <PriceValue class="table-price total" :price="estimateTotal.price" />
      <PriceValue
        class="table-price total"
        :price="estimateTotal.overheadPrice"
      />
      <PriceValue
        v-if="servicePrice > 0"
        class="table-price total"
        :price="estimateTotal.servicePrice"
      />
      <p v-else class="table-price">-</p>
      <PriceValue class="table-price total" :price="estimateTotal.sum" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch, computed, ref } from "vue";
import { PriceValue } from "@/shared";

import { useInstallationStore } from "@/stores/new/installation.store";
import { useEstimateReviewStore } from "@/stores/new/estimateReview.store";
import { useExtraStore } from "@/stores/new/extra.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useOverheadStore } from "@/stores/new/overhead.store";

const estimateReviewStore = useEstimateReviewStore();
const estimateStore = useNewEstimateStore();
const extraStore = useExtraStore();
const installationStore = useInstallationStore();
const overheadStore = useOverheadStore();

const servicePrice = ref(0);
const dealType = computed(() => estimateStore.estimate.dealTypeCode);
const activeOveheadItems = computed(() => overheadStore.activeOveheadItems);

const estimateItemList = computed(() => estimateReviewStore.estimateItemList);
const estimateTotal = computed(() => estimateReviewStore.estimateTotal);

watch(
  () => [
    estimateReviewStore.materialPriceSum,
    estimateStore.estimate.deliverySum,
    installationStore.halfInstallationSum,
    extraStore.extraTotal,
    activeOveheadItems.value,
  ],
  () => {
    estimateReviewStore.createEstimateItemList();
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  () => [estimateReviewStore.estimateItemList],
  () => {
    estimateReviewStore.updatePartitionsTableTotal();
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  () => [estimateReviewStore.estimateTotal],
  () => {
    servicePrice.value = estimateTotal.value?.servicePrice
      .getSystemPrice(dealType.value)
      .getValue();
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<style scoped>
.table {
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  color: #052141;

  margin-bottom: 16px;
}

.table-row {
  display: grid;
  align-items: center;
  grid-template-columns: 0.3fr 1.2fr 0.5fr 0.5fr 0.7fr repeat(4, 1fr);
  margin-bottom: 8px;
}

.table-row.total {
  margin-top: 16px;
}

.table-price {
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  color: #052141;
  text-align: center;
}

.table-price.total {
  font-weight: 600;
  font-size: 15px;
}

.center {
  text-align: center;
}
</style>
